import logo from "../../assets/logo.png";

function Logo() {
  return (
    <img src={logo} alt="CoolJob Logo" style={{ height: "40px" }} />
  );
}

export default Logo;
